/**
 * Account verification by DOB component
 */
Vue.component('dob-verification', {
  template: `
  <div class="form-field secondary-lookup__dob">
    <label for="dob-input" id="dob-label">
      Date of Birth of Primary Account Holder
      <input id="dob-input" name="dob[]" type="text" placeholder="MM / DD / YYYY" v-mask="'## / ## / ####'" class="w-100"
        v-bind:value="value"
        v-bind:index="index"
        v-bind:disabled="disable"
        v-on:keyup="keyupOnVerifyField"
        v-on:input="$emit('input', $event.target.value)"
        >
    </label>
  </div>
  `,

  /**
   * Props array
   */
  props: {
    value: { required: true },
    index: { default: null },
    disable: { default: false },
  },

  methods: {
    keyupOnVerifyField() {
      this.$emit('dob-verification');
    },
  },

});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/vue/components/dobVerification.js